const requiredValidation = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0 && value.every(
      (lValue) => typeof lValue === "string" ? !!lValue && lValue.replace(/\s/g, "").length > 0 : Number.isFinite(lValue)
    );
  }
  if (typeof value === "string") return !!value && value.replace(/\s/g, "").length > 0;
  if (typeof value === "number") return Number.isFinite(value);
  return true;
};
const nameValidation = (newName, values) => {
  const hasValue = requiredValidation(newName);
  if (!hasValue) return "Name is required";
  if (Object.keys(values).includes(newName)) return "Name already exists";
  return null;
};
const dateValidation = (value) => {
  const hasValue = requiredValidation(value);
  if (!hasValue) return "Date is required";
  const valid = value.every((lValue) => {
    const date = new Date(lValue);
    const validDate = date instanceof Date && !Number.isNaN(date.getTime());
    return validDate;
  });
  return valid ? null : "Invalid date value";
};
const numberValidation = (value) => {
  const hasValue = requiredValidation(value);
  if (!hasValue) return "Number is required";
  const valid = value.every((lValue) => lValue && Number.isFinite(Number(lValue)));
  return valid ? null : "Invalid number";
};
const valueValidationByType = (value, type) => {
  switch (type) {
    case "STRING":
      if (!requiredValidation(value)) return "A value is required";
      return null;
    case "DATE":
      return dateValidation(value);
    case "NUMBER":
      return numberValidation(value);
    default:
      return "Invalid type selected";
  }
};
export const customFieldValidation = (customFields) => (values) => {
  const errors = {};
  const nameError = nameValidation(values.name, customFields);
  const valuesError = valueValidationByType(values.values, values.type);
  if (nameError) errors.name = nameError;
  if (valuesError) errors.values = valuesError;
  return errors;
};
